(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1705],{

/***/ 11609:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customers/[customer]",
      function () {
        return __webpack_require__(75328);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 83718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56475);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);






const CustomerCard = (param)=>{
    let { imageSrc , customerName , customerDescription , bgColor , isCaseStudy , customerKey  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full h-[470px] flex flex-col items-center justify-between rounded-xl overflow-hidden mt-3  border border-gray-300 transition-all duration-500 ease-in-out bg-white",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full h-[225px] flex justify-center items-center overflow-hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: imageSrc,
                    loading: "lazy",
                    alt: customerName,
                    width: "350",
                    height: "350",
                    className: "w-full h-full object-cover"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full h-60 flex flex-col justify-between items-start p-7 pt-0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col justify-between items-start",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "text-2xl font-semibold mt-4",
                                children: customerName
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-base mt-2",
                                children: customerDescription
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_1__/* .CLMLinkPrimaryArrow */ .c$, {
                        buttonUrl: isCaseStudy && customerKey ? "/signature/case-studies/".concat(customerKey) : "/customers/".concat(customerName.replaceAll(" ", "")),
                        buttonText: "Read Testimonial"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomerCard);


/***/ }),

/***/ 75328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_CustomerCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83718);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);





const Customer = (param)=>{
    let { customerTestimonial  } = param;
    // Customer Testimonial Cards Data
    let customerCardJson = [
        {
            imageSrc: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/customer-testimonial/13.png",
            customerName: "Crumbl Cookies",
            bgColor: "bg-green-100/50",
            customerDescription: "Discover how Crumble Cookies achieved 80% faster approvals with BoloForms automated workflows."
        },
        {
            imageSrc: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/customer-testimonial/1.png",
            customerName: "Leadschool",
            bgColor: "bg-red-100/50",
            customerDescription: "Leadschool moves 30-40% faster with BoloForms Approvals"
        },
        {
            imageSrc: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/customer-testimonial/3.png",
            customerName: "Flipkart",
            bgColor: "bg-yellow-100/50",
            customerDescription: "Flipkart streamlines operations using BoloForms Approvals."
        },
        {
            imageSrc: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/customer-testimonial/5.png",
            customerName: "MPL AutoGroup",
            bgColor: "bg-pink-100/50",
            customerDescription: "MPL Autogroup launches more effective employee reimbursements with BoloForms"
        },
        {
            imageSrc: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/customer-testimonial/7.png",
            customerName: "Airasia",
            bgColor: "bg-orange-100/50",
            customerDescription: "Airasia drives global collaboration with BoloForms"
        },
        {
            imageSrc: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/customer-testimonial/9.png",
            customerName: "Saya Stationery",
            bgColor: "bg-green-100/50",
            customerDescription: "Saya Stationary finds a better way to build and grow with BoloForms"
        },
        {
            imageSrc: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/customer-testimonial/11.png",
            customerName: "XPO Logistics",
            bgColor: "bg-yellow-100/50",
            customerDescription: "XPO Logistics optimizes workflows and tightens security with BoloForms"
        },
        {
            imageSrc: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/customer-testimonial/15.png",
            customerName: "Great Lakes Ace Hardware",
            bgColor: "bg-green-100/50",
            customerDescription: "Great Lakes Ace Hardware aligns its nationwide operational team with BoloForms"
        }
    ];
    customerCardJson = customerCardJson.filter((customerCard)=>{
        return (customerCard === null || customerCard === void 0 ? void 0 : customerCard.customerName) !== (customerTestimonial === null || customerTestimonial === void 0 ? void 0 : customerTestimonial.customerName);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full flex flex-col justify-center items-center mt-20 md:mt-36",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "BoloSign Customer | ".concat(customerTestimonial === null || customerTestimonial === void 0 ? void 0 : customerTestimonial.customerName)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "BoloSign helps you automate your Workflow With Google Forms. With BoloSign, you can create custom forms & manage your data easily. Get started today!"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.region",
                        content: "IN"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.position",
                        content: "22.351115;78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "ICBM",
                        content: "22.351115, 78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "author",
                        content: "BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "publisher",
                        content: "BoloSign "
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/customers/".concat(customerTestimonial === null || customerTestimonial === void 0 ? void 0 : customerTestimonial.customerName)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/customers/".concat(customerTestimonial === null || customerTestimonial === void 0 ? void 0 : customerTestimonial.customerName)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "BoloSign Customer | ".concat(customerTestimonial === null || customerTestimonial === void 0 ? void 0 : customerTestimonial.customerName)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: "BoloSign helps you automate your Workflow With Google Forms. With BoloSign, you can create custom forms & manage your data easily. Get started today!"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:domain",
                        content: "https://bolosign.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://www.bolosign.com/customers/".concat(customerTestimonial === null || customerTestimonial === void 0 ? void 0 : customerTestimonial.customerName)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "How to Create Google Forms Approval Workflow - BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: "BoloSign helps you automate your Workflow With Google Forms. With BoloSign, you can create custom forms & manage your data easily. Get started today!"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                    })
                ]
            }),
            customerTestimonial ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        // style={{ background: customerTestimonial.banner.color }}
                        className: "w-full max-w-screen-lg mx-auto h-full relative flex justify-center items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full h-full sm:h-full flex justify-center items-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                width: "700",
                                height: "342",
                                className: "w-full h-full text-center removeBg",
                                src: customerTestimonial.banner.imgSrc,
                                alt: "banner",
                                loading: "eager"
                            }, "bannerImg")
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "md:mt-12 max-w-screen-lg mx-auto ",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "text-2xl md:text-5xl sm:text-4xl font-semibold leading-normal mt-10",
                                children: customerTestimonial.heading
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-full flex justify-between items-center mt-3 mb-8",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "w-full flex justify-start items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "w-10 h-10 flex justify-center items-center rounded-full overflow-hidden",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                    src: customerTestimonial.wrritenBy.profileImg,
                                                    className: "w-full h-full rounded-full object-cover",
                                                    width: 10,
                                                    height: 10,
                                                    alt: "profile"
                                                }, "profileImg")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                className: "text-base",
                                                children: [
                                                    customerTestimonial.wrritenBy.name,
                                                    ", ",
                                                    customerTestimonial.writtenOn
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex justify-center items-start ml-3"
                                    })
                                ]
                            }),
                            customerTestimonial.content.map((info, index)=>{
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                                    children: [
                                        (info === null || info === void 0 ? void 0 : info.heading) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "text-xl md:text-2xl leading-normal text-black font-semibold mt-5 md:mt-12",
                                            children: info.heading
                                        }, "heading" + index),
                                        (info === null || info === void 0 ? void 0 : info.quote) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "w-full flex flex-col justify-center items-end mt-5",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                                    className: "w-full text-lg text-center font-semibold italic leading-relaxed text-black",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "text-2xl text-[#915bff]",
                                                            children: '"'
                                                        }),
                                                        info.quote,
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "text-2xl text-[#915bff]",
                                                            children: '"'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                                    className: "text-lg flex justify-center items-center text-gray-600 pr-6 sm:pr-20 mt-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "h-[3px] w-5 bg-[#915bff] block mr-2"
                                                        }),
                                                        info.quoteBy
                                                    ]
                                                })
                                            ]
                                        }, "quote" + index),
                                        (info === null || info === void 0 ? void 0 : info.para) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "text-base md:text-lg my-4 text-gray-900",
                                            children: [
                                                (info === null || info === void 0 ? void 0 : info.paraHeading) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                    className: "capitalize font-semibold text-lg my-4 text-black",
                                                    children: [
                                                        info === null || info === void 0 ? void 0 : info.paraHeading,
                                                        " "
                                                    ]
                                                }),
                                                info.para
                                            ]
                                        }, "para" + index),
                                        (info === null || info === void 0 ? void 0 : info.tags) && (info === null || info === void 0 ? void 0 : info.tags.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-full flex flex-wrap justify-start items-center gap-2 mt-4",
                                            children: info.tags.map((tag, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "px-4 py-2 bg-[#915bff] text-white font-semibold rounded-lg",
                                                    children: tag
                                                }, "tag" + index))
                                        }, "tags" + index),
                                        (info === null || info === void 0 ? void 0 : info.imgSrc) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-full flex justify-center items-center mt-6",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                src: info.imgSrc,
                                                width: "800",
                                                height: "400",
                                                loading: "lazy",
                                                alt: "",
                                                className: "w-full sm:w-fit mt-4"
                                            })
                                        }, "img" + index)
                                    ]
                                }, index);
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-full mt-20",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "w-full flex justify-center items-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "w-full h-[2px] bg-[#915bff]"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: "text-lg font-semibold mx-4 text-gray-900",
                                                children: "Author"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "w-full h-[2px] bg-[#915bff]"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "w-full flex flex-col sm:flex-row justify-center items-center mt-10 sm:gap-10",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "w-full sm:w-fit flex justify-start items-center gap-5",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "w-12 sm:w-28 h-12 sm:h-28",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "w-full sm:w-28 h-full sm:h-28 flex justify-center items-center rounded-full overflow-hidden",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                                src: customerTestimonial.wrritenBy.profileImg,
                                                                className: "w-full h-full object-cover",
                                                                width: 10,
                                                                height: 10,
                                                                alt: "profile"
                                                            }, "profileImgBottom")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                        className: "text-lg sm:hidden font-semibold",
                                                        children: customerTestimonial.wrritenBy.name
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex flex-col justify-center items-start mt-5",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "hidden sm:block text-lg font-semibold",
                                                        children: customerTestimonial.wrritenBy.name
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "text-base text-gray-900",
                                                        children: customerTestimonial.wrritenBy.desc
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full max-w-screen-mxl mx-auto flex justify-center items-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "text-2xl font-semibold my-10",
                    children: "Customer Not Found"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "w-full max-w-screen-mxl mx-auto border-t-2 border-[#915bff] block bg- mt-20"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "text-xl md:text-2xl text-center font-semibold mt-10",
                children: "RECOMMENDED ARTICLES"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full flex justify-center items-center mt-10",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-full max-w-screen-xl mx-auto grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 place-items-center gap-[20px]",
                    children: customerCardJson.slice(0, 3).map((customer, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CustomerCard__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            ...customer
                        }, index))
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Customer);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(11609); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);